<template>
  <dropdown :dropup="dropup" tag="div">
    <slot name="default">
      <a class="dropdown-toggle" role="button">
        Options
      </a>
    </slot>
    <template slot="dropdown">
      <li v-for="o in options"
          :key="`preference-${o.id}`"
          class="detail-checkbox"
          :class="{ 'divider': o.divider, disabled: o.disabled && o.disabled() }">
        <a v-if="!o.divider"
           v-tooltip.right.unenterable="impl.tooltip(o.tooltip)"
           role="button"
           @click.stop="click(o)">
          {{ o.text }}
          <span v-if="o.config[o.field]"
                class="glyphicon text-success glyphicon-ok pull-right"
                aria-hidden="true"></span>
          <span v-else
                class="glyphicon text-danger glyphicon-remove pull-right"
                aria-hidden="true"></span>
        </a>
      </li>
    </template>
  </dropdown>
</template>
<script>

const impl = {
  tooltip: function (t) {
    if (t == null) {
      return ''
    }

    return `<span class="hint-tooltip">${t}</span>`
  }
}

export default {
  name: 'checkbox-menu',

  props: {
    options: {
      type: Array,
      required: true
    },

    dropup: {
      type: Boolean,
      required: false
    }
  },

  data: function () {
    return {
      impl: impl
    }
  },

  methods: {
    click: function (option) {
      if (option.disabled && option.disabled()) {
        return
      }

      option.click()
    }
  }
}
</script>
<style scoped>
li {
  min-width: 25rem;
}
</style>
